module.exports = __webpack_public_path__ + "img/KAMALAYAN_LOGO.53f7aeff.png";